import React from 'react'
import styled from 'styled-components'
import { IconArrowDown } from '../../iconography/Icons/Icons'

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  appearance: none;
  padding: 0;
  border: 0;
  outline: none;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  background-color: ${props => props.theme.color.primary50};
  cursor: pointer;
`
const Icon = styled(IconArrowDown)`
  fill: ${props => props.theme.color.primary500};
  transition: 0.2s transform ease-in;

  [data-collapsed='true'] > & {
    transform: rotate(180deg);
  }
`

export const CollapseButton: React.FC<{ disabled?: boolean; onClick(): void; collapsed: boolean }> = ({
  collapsed,
  onClick,
}) => {
  return (
    <Button onClick={onClick} data-collapsed={collapsed}>
      <Icon />
    </Button>
  )
}
